module.exports = __webpack_public_path__ + "img/inviateTask.e73f0dc2.png";